<template>
  <div
    v-bind="$attrs"
    class="tw-mb-2 tw-px-4 tw-py-1 app-chat-message tw-duration-300"
  >
    <div class="tw-w-full">
      <el-row class="tw-w-full tw-flex-nowrap">
        <slot name="default" />
        <slot name="message" />
      </el-row>
    </div>
  </div>
</template>
